import { BrowserRouter, Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/hooks/useAuth";
import { Toaster } from "sonner";
import { useEffect } from "react";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Session1 from "@/pages/Session1";
import GenericSession from "@/pages/GenericSession";
import Progreso from "@/pages/Progreso";
import Anexos from "@/pages/Anexos";
import Admin from "@/pages/Admin";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--ha-bg)]">
        <div className="text-[var(--ha-muted)]">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  // Listen for messages from the Service Worker (push notification click)
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const handler = (event) => {
      if (event.data?.type === "NAVIGATE" && event.data.url) {
        try {
          const url = new URL(event.data.url, window.location.origin);
          navigate(url.pathname + url.search + url.hash);
        } catch {}
      }
    };
    navigator.serviceWorker.addEventListener("message", handler);
    return () => navigator.serviceWorker.removeEventListener("message", handler);
  }, [navigate]);
  // Detect OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/sesion/1" element={<ProtectedRoute><Session1 /></ProtectedRoute>} />
      <Route path="/sesion/:num" element={<ProtectedRoute><GenericSession /></ProtectedRoute>} />
      <Route path="/progreso" element={<ProtectedRoute><Progreso /></ProtectedRoute>} />
      <Route path="/anexos" element={<ProtectedRoute><Anexos /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App ha-noise">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
